export default __webpack_public_path__ + "img/kingnon-48667bee.png";